// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_nd-0";